"use client"
import ContentOne from "../../../ContentOne"
import { BlockType } from '@/libs/types';
import clsx from 'clsx';
import React from 'react'
import { Tab, Tabs } from 'react-bootstrap';
import PricingContentTable from '../../shared/PricingContentTable';
import ImageCustom from "@/components/Image";
import TooltipExplaination from "../TooltipExplaination";

const Partners: React.FC<{ block: BlockType, locale: string }> = ({ block, locale }) => {
    return (
        <Tabs defaultActiveKey={1} id="uncontrolled-tab" className="justify-content-center">
            {block.blocks?.concat(block?.tables?.map((item: any) => ({
                ...item, type: "ContentTable"
            }))).map((item: any, index: number) => {
                if (item.type && item.type === "ContentTable") {
                    return (
                        <Tab eventKey={index} key={index} title={item?.name}>
                            <div className="container">
                                <div className="row justify-content-center py-5">
                                    <div className="col-md-11 col-12">
                                        <div className="tables table-responsive">
                                            <PricingContentTable locale={locale} table={item} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    )
                }
                if (item.blocks && (item.blocks.length === 0 && item.content === null)) return null;
                return (
                    <Tab eventKey={index} title={item.title} key={index}>
                        <div className={clsx('py-5', item.classes)}>
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-md-11 col-12">
                                        <div className="row justify-content-center">
                                            {(item.content && (item.content !== '')) && (
                                                <div className="row justify-content-center">
                                                    <div className="col-md-11 col-12">
                                                        <ContentOne locale={locale} variant="h4" block={item} />
                                                    </div>
                                                </div>
                                            )}
                                            {(item.blocks && (item.blocks.length !== 0)) && item.blocks.map((item: any, index: number) => {
                                                return (
                                                    <div className={"col-md-4 col-12 mb-md-4 mb-3"} key={index}>
                                                        <div className={clsx('item', 'h-100')}>
                                                            <div className={clsx('item-wrapper', 'h-100', item.classes)}>
                                                                {(item.thumb) && (<div className={clsx('mb-4')}>
                                                                    <ImageCustom src={item.thumb} width={150} height={50} aspectratio="1:" alt={item.title} />
                                                                </div>)}
                                                                <ContentOne locale={locale} variant="h3" block={item} />
                                                                {item.metadata?.explaination && (<TooltipExplaination locale={locale} explaination={item.metadata?.explaination} />)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                )
            })}
        </Tabs>
    )
}

export default Partners